import { handleActions } from 'redux-actions';
import { NotificationManager } from "react-notifications";
import { initialize as initializeForm } from 'redux-form';
import { api } from "api";

let url = 'cost-of-row-material';
let form = 'CostosMPForm';
// ------------------------------------
// Constants
// ------------------------------------
export const constants = {
    LOADER: 'COSTO_MP_LOADER',
    DATA_COMPRAS: 'COSTO_MP_COMPRAS',
    ITEM_DATA: 'COSTO_MP_ITEM',
    TAB_EN_CURSO: 'COSTO_MP_TAB_EN_CURSO',
    CURRENCY:'CURRENCY_SALES'
}

// -----------------------------------
// Pure Actions
// -----------------------------------
const setLoader = loader => ({
    type: constants.LOADER,
    loader,
});
const setDataCompras = dataCompras => ({
    type: constants.DATA_COMPRAS,
    dataCompras,
});

const setItem = item => ({
    type: constants.ITEM_DATA,
    item,
});


// -----------------------------------
// Actions
// -----------------------------------
const getCostOfRowMaterial = () => (dispatch) => {
    dispatch(setLoader(true));

    api.get(`${url}/get_cost_of_row_material`)
        .then((response) => {
            dispatch(setDataCompras(response));
            dispatch(initializeForm(form, response));
        })
        .catch((error) => {
            console.error('Error fetching data:', error);
            NotificationManager.error((error && error.detail) ? error.detail : 'Error en lectura de datos', 'ERROR', 3000);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

const getDollar = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`administrative/get_dollar_exchange`).then((response) => {
        dispatch(setItem(response.dollar_exchange));
        dispatch(initializeForm(form, response.results));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const editar = (id, data) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`${url}/${id}`, data).then(() => {
        NotificationManager.success('Registro actualizado', 'Éxito', 3000);
        dispatch(getCostOfRowMaterial())
        dispatch(setCurrency('USD'));
    }).catch(() => {
        NotificationManager.error((error && error.detail) ? error.detail : 'Error en la edición', 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const setTab = (tab) => (dispatch) => {
    dispatch(setLoader(true));
    dispatch({ type: constants.TAB_EN_CURSO, tab });
    dispatch(setLoader(false));
};

const convertirMoneda = ({ latex_data, solido_data, skim_data, item, change, currency }) => (dispatch) => {
    const tasa = parseFloat(item || 1);
    const convertirADolares = currency === 'USD';
    const factor = convertirADolares ? (1 / tasa) : tasa;

    const tablas = [
        { data: latex_data, prefix: 'latex_data' },
        { data: solido_data, prefix: 'solido_data' },
        { data: skim_data, prefix: 'skim_data' },
    ];

    tablas.forEach(({ data, prefix }) => {
        if (!data) return;

        Object.keys(data).forEach((month) => {
            const monthData = data[month];
            if (!monthData) return;

            Object.keys(monthData).forEach((seccion) => {
                const fila = monthData[seccion];
                if (!fila) return;

                const kgs = parseFloat(fila.kgs_secos || 0);
                const costo = parseFloat(fila.costo_kg_seco || 0);

                const nuevoCosto = (costo * factor).toFixed(5);
                const nuevoTotal = (kgs * parseFloat(nuevoCosto)).toFixed(2);

                change(`${prefix}.${month}.${seccion}.costo_kg_seco`, nuevoCosto);
                change(`${prefix}.${month}.${seccion}.valor_total`, nuevoTotal);
            });
        });
    });
};

const setCurrency = (currency) => (dispatch) => {
    dispatch({ type: constants.CURRENCY, currency })

}

export const actions = {
    editar,
    getCostOfRowMaterial,
    getDollar,
    setTab,
    convertirMoneda,
    setCurrency
};

// -----------------------------------
// Reducers
// -----------------------------------
const reducers = {
    [constants.LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [constants.DATA_COMPRAS]: (state, { dataCompras }) => {
        return {
            ...state,
            dataCompras,
        };
    },

    [constants.ITEM_DATA]: (state, { item }) => {
        return {
            ...state,
            item,
        };
    },
    [constants.TAB_EN_CURSO]: (state, { tab }) => {
        return {
            ...state,
            tab,
        };
    },
    [constants.CURRENCY]: (state, { currency }) => {
        return {
            ...state,
            currency,
        };
    },

};
export const initialState = {
    loader: false,
    dataCompras: {
        results: [],
        count: 0,
    },
    item: {},
    tab: 'EN_CURSO',
    currency:'USD'


};
export default handleActions(reducers, initialState)
